import { AxiosResponse } from "axios";
import {
  IInformationTypeAccess,
  IInformationTypePermissionSet,
} from "../models/informationType";
import api from "../utils/api";

type InformationTypePermissionTarget =
  | { roleId: number; groupId?: never }
  | { roleId?: never; groupId: number };

const getAvailable = async (): Promise<
  AxiosResponse<IInformationTypeAccess[]>
> => api.get(`/api/InformationType`);

const getPermissions = async (
  params: InformationTypePermissionTarget
): Promise<AxiosResponse<IInformationTypePermissionSet>> =>
  api.get(`/api/InformationType/Permissions`, { params });

const updatePermissions = async (
  data: IInformationTypePermissionSet
): Promise<AxiosResponse<IInformationTypePermissionSet>> =>
  api.put(`/api/InformationType/Permissions`, data);

const informationTypeApi = {
  getAvailable,
  getPermissions,
  updatePermissions,
};

export default informationTypeApi;
